/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrayDataProvider = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m3.68 15.31.482-1.498h2.695l.482 1.498h1.75L6.294 8H4.775L2 15.31zm2.744-2.825h-1.84L5.5 9.609zm5.702 2.825c1.2 0 2.103-.31 2.71-.93s.91-1.527.91-2.72c0-1.207-.305-2.118-.915-2.735C14.22 8.308 13.319 8 12.126 8H9.672v7.31zm-.02-1.277h-.865V9.277h.865c.683 0 1.19.194 1.518.583.328.389.493.989.493 1.8s-.166 1.41-.498 1.795c-.332.385-.836.578-1.513.578zm6.113 1.277v-2.363h1.056c.898 0 1.577-.21 2.036-.628.46-.42.689-1.034.689-1.845 0-.818-.23-1.435-.689-1.85C20.852 8.207 20.173 8 19.275 8h-2.614v7.31zm.734-3.64h-.734V9.277h.734c.537 0 .917.09 1.142.272.224.18.336.489.336.925 0 .429-.112.735-.336.92-.225.184-.605.276-1.142.276z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArrayDataProvider as ArrayDataProvider };
